import * as React from "react";
import { RightTopTag, LeftTopTag, LeftBottomTag } from "./styles";
export const ProductImageTagViews = (props) => {
    const { columnNum, rightTopTag, leftTopTag, leftBottomTag } = props;
    return (React.createElement("div", null,
        rightTopTag && React.createElement(RightTopTag, { gridCol: columnNum, src: rightTopTag }),
        leftTopTag && React.createElement(LeftTopTag, { gridCol: columnNum, src: leftTopTag }),
        leftBottomTag && React.createElement(LeftBottomTag, { src: leftBottomTag })));
};
